import React, { Component } from 'react'
import * as R from 'ramda'
import { intervalToDuration } from 'date-fns'

import Select from '../../../form/Select'
import Panel from '../../../../UniformComponents/Panel'
import DataTable from '../../../DataTable'

import './timeTracking.scss'

class SurveyTimeTracking extends Component {
    columns = [
        {
            name: 'Client ID',
            key: 'clientId',
        },
        {
            name: 'Client Name',
            key: 'clientName',
        },
        {
            name: 'Survey ID',
            key: 'surveyId',
        },
        {
            name: 'Product Name',
            key: 'productName',
        },
        {
            name: 'Product Year',
            key: 'year',
        },
        {
            name: 'Entry Started Timestamp',
            key: 'startDate',
        },
        {
            name: 'Entry Completed Timestamp',
            key: 'completedDate',
        },
        {
            name: 'Time Difference',
            key: 'timeDiff',
            dataTransform: (timeDiff) => {
                const duration = intervalToDuration({ start: 0, end: timeDiff * 1000 })

                return (
                    <span>{this.durationToString(duration)}</span>
                )
            },
        },
    ]

    constructor(props) {
        super(props)

        const { store } = props

        store.breadcrumps = [
            {
                name: 'completionTracking',
                url: '/intranet/completionTimeTracking',
                title: 'Completion Time Tracking',
            },
        ]

        this.state = {
            clients: [],
            rows: [],
        }
    }

    async componentDidMount() {
        const { store } = this.props

        const [response, rows] = await Promise.all([
            store.http.get('/intranet/completionTimeTracking/client'),
            store.http.get('/intranet/completionTimeTracking'),
        ])

        this.setState({
            clients: response.map(({ clientId, name }) => ({
                value: clientId,
                label: name,
            })),
            rows,
        })
    }

    durationToString = (duration) => (
        ['years', 'months', 'days', 'hours', 'minutes', 'seconds'].reduce((str, k) => {
            const value = duration[k]
            const separator = !R.isEmpty(str)
                ? ', '
                : ''
            return str + (
                value
                    ? `${separator}${value} ${k}`
                    : ''
            )
        }, '')
    )

    changeClient = async ({ value }) => {
        const { store } = this.props

        const rows = value
            ? await store.http.get(`/intranet/completionTimeTracking?clientId=${value}`)
            : await store.http.get('/intranet/completionTimeTracking')

        this.setState({
            rows,
        })
    }

    render() {
        const { rows, clients } = this.state
        return (
            <Panel cssClass="completionTracking">
                <div>
                    <Select
                        options={clients}
                        placeholder="All"
                        isClearable
                        blurOnClear
                        onBlur={this.changeClient}
                    />
                </div>
                {rows.length > 0 && (
                    <div>
                        <DataTable
                            store={{}}
                            inMemory
                            dataSet={rows}
                            columns={this.columns}
                        />
                    </div>
                )}
            </Panel>
        )
    }
}

export default SurveyTimeTracking
